<ng-container *ngIf="showLayers">
    <app-control-mapping *ngIf="activeLayerId == 'm'"></app-control-mapping>
    <app-control-fog *ngIf="activeLayerId == 'f'"></app-control-fog>
    <app-control-graffiti *ngIf="activeLayerId == 'g'"></app-control-graffiti>
    <app-control-uploads *ngIf="activeLayerId == 'u'"></app-control-uploads>
    <app-control-tokens *ngIf="activeLayerId == 't'"></app-control-tokens>
</ng-container>
<ng-container *ngIf="showLayers==false">
    <app-control-tokens></app-control-tokens>
</ng-container>

<div id="layer-list">
    <ng-container *ngIf="showLayers">
        <div class="layer" *ngFor="let layer of layers; let i = index" [ngClass]="{'active': layer.id == activeLayerId}">
            <button mat-icon-button (click)="toggleVisibility(layer.id, i)">
                <mat-icon *ngIf="layer.visible">visibility</mat-icon>
                <mat-icon *ngIf="!layer.visible">visibility_off</mat-icon>
            </button>
            <span class="layer-name" (click)="setActive(layer.id)">{{ layer.name }}</span>
            <div class="layer-indicator">
                <span class="layer-key">{{ layer.key }}</span>
            </div>
        </div>
    </ng-container>
</div>